import React , {useState , useEffect} from 'react';

//components
import MainPage from './components/MainPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



//hooks
import useGetTemplateParameters from './hooks/useGetTemplateParameters';
import SearchModal from './shared/SearchModal';


const App = () => {

  //for get parameters
  const [templateParameter, setTemplateParameter] = useGetTemplateParameters();
  const keyRender = Object.keys(templateParameter).length;

  //for switch beetween searchModal and mainComponent
  const [keyShowSearchModal, setKeyShowSearchModal] = useState(false);
  const showSearchModal = templateParameter.showSearchModal ?? "";
  let timeWaite = templateParameter.timeWaite ?? "";
  if (timeWaite === "") timeWaite = "3";


  useEffect(() => {

    if (showSearchModal == "1") {

      setTimeout(() => {

        setKeyShowSearchModal(true);

      }, (+timeWaite * 1000) + 3000);


    }


  }, [keyRender])



  if (showSearchModal !== "1") {

    return (

      keyRender ?
        <>

          <MainPage templateParameter={templateParameter} keyRender={keyRender} />
          <ToastContainer rtl />


        </>

        :

        <></>


    )
  }
  else {

    return (

      keyRender ?
        <>



          {keyShowSearchModal ?


            <MainPage templateParameter={templateParameter} keyRender={keyRender} />

            :

            <SearchModal templateParameter={templateParameter} timeWaite={timeWaite} />
          }

          <ToastContainer rtl />
        </>

        :

        <></>

    )

  }

};

export default App;